import { numberFormatter } from 'components/AgGrid/utils';
import type { CatalogUerBaseCostEstimateBasisItem } from 'gql/graphql';
import { CodeCellRendererComponent } from 'pages/Catalogs/Common/EstimateBasisModal/components/CodeCellRendererComponent';

import type { ColDef } from 'ag-grid-community';
import type { CellClassParams } from 'ag-grid-community/dist/types/core/entities/colDef';
import cn from 'classnames';
import { useMemo } from 'react';

import { AgGridCustomFilterAdapter } from '../../../../../../components/CustomTableFilter';
import type { TNestedColumns } from '../helpers';

const cellClass = (cellClassParams: CellClassParams<CatalogUerBaseCostEstimateBasisItem>) => {
    const { isHeadLine, isDeleted, isNotCount } = cellClassParams.data || {};

    return cn({
        'is-ordinary-row': !isHeadLine,
        'is-headline': isHeadLine,
        'is-deleted': isDeleted,
        'is-not-count': isNotCount,
        'is-right-aligned': cellClassParams.colDef.field === 'unitCost',
    });
};

export const useCatalogUERBaseCostEstimateBasisColumns = ({ currentFilterData, onFiltersUpdated }: TNestedColumns) =>
    useMemo<ColDef<CatalogUerBaseCostEstimateBasisItem>[]>(() => {
        const typedCurrentFilterData = currentFilterData as CatalogUerBaseCostEstimateBasisItem[];

        return [
            {
                field: 'code',
                headerName: 'Шифр',
                width: 200,
                cellClass,
                cellRenderer: CodeCellRendererComponent,
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    hideTableHeader: true,
                    changeFilterHandler: onFiltersUpdated,
                    filterItems: typedCurrentFilterData
                        ?.filter(({ isHeadLine }) => !isHeadLine)
                        .map(({ code }) => ({
                            label: code,
                        })),
                    columns: [
                        {
                            headerName: 'Шифр',
                            field: 'label',
                            checkboxSelection: true,
                            width: 400,
                        },
                    ],
                    isClientSideSearch: true,
                    childFieldAccessor: 'label',
                },
            },
            {
                field: 'name',
                headerName: 'Наименование',
                flex: 1,
                cellClass,
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    hideTableHeader: true,
                    changeFilterHandler: onFiltersUpdated,
                    filterItems: typedCurrentFilterData
                        ?.filter(({ isHeadLine }) => !isHeadLine)
                        .map(({ name }) => ({
                            label: name,
                        })),
                    columns: [
                        {
                            headerName: 'Наименование',
                            field: 'label',
                            checkboxSelection: true,
                            width: 400,
                        },
                    ],
                    isClientSideSearch: true,
                    childFieldAccessor: 'label',
                },
            },
            {
                field: 'unit',
                headerName: 'Ед.изм.',
                width: 120,
                cellClass,
            },
            {
                field: 'unitCost',
                headerName: 'Стоимость единицы в базисном уровне цен',
                width: 200,
                valueFormatter: numberFormatter(2),
                cellClass,
            },
        ];
    }, [currentFilterData, onFiltersUpdated]);
